
export default {
  data() {
    return {
      options: [
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
      statisticsOptions: [
        {
          name: "number",
          label: "Broj",
          type: "number",
        },
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$isInViewport(this.$t("id.onlineShoppig"));
    });
  },
};
